import { EmailTemplateSystemSlug } from '../enums';
import type {
	InvoiceDetailEmailTemplateDataInterface,
	OrderDetailEmailTemplateDataInterface,
} from '../models';

export const DefaultEmailTemplateData = {
	[EmailTemplateSystemSlug.ORDER_DETAIL]: {
		CART: {
			hideTopRightHeader: true,
			hidePaymentFields: true,
			hideShippingFields: true,
			footerMessage: 'Thank you for your business.',
		} as Partial<OrderDetailEmailTemplateDataInterface>,
		ORDER: {
			footerMessage: 'Thank you for your business.',
		} as Partial<OrderDetailEmailTemplateDataInterface>,
		QUOTE: {
			hidePaymentFields: true,
			hideShippingFields: true,
			footerMessage:
				'Please reach out to your salesperson when you are ready to place an order.',
		} as Partial<OrderDetailEmailTemplateDataInterface>,
	},
	[EmailTemplateSystemSlug.INVOICE_DETAIL]: {
		footerMessage: 'Your invoice is attached. Thank you for your business.',
	} as Partial<InvoiceDetailEmailTemplateDataInterface>,
};
